import VueRouter from 'vue-router';
import type { Location } from 'vue-router';

/**
 * 需要在URL上传递的querystring参数
 */
export const transferQueries = ['hasNavBar', 'brand', 'eac', 'hasAppInfo'];

export default function transferQueriesGuard(router: VueRouter) {
  let isReplace = false;
  const originalReplace = router.replace;

  // @ts-expect-error It's not an error
  router.replace = (...args: any) => {
    isReplace = true;
    return originalReplace.apply(router, args);
  };

  router.afterEach(() => {
    isReplace = false;
  });

  /**
   * querystring参数透传，通常用于全局参数
   * 注意非特殊情况尽量使用Store
   */
  router.beforeEach((to, from, next) => {
    let transferred = true;
    const transferredQueries = Object.keys(from.query).reduce(
      (acc, key) => {
        if (transferQueries.includes(key)) {
          acc[key] = from.query[key] as string;

          // 检测目标路径是否存在未传递的querystring参数
          if (to.query[key] !== from.query[key]) {
            transferred = false;
          }
        }

        return acc;
      },
      {} as Record<string, string>,
    );

    if (transferred) {
      next();
      return;
    }

    if (Object.keys(transferredQueries).length > 0) {
      next({
        ...(to as Location),
        query: {
          ...to.query,
          ...transferredQueries,
        },
        replace: isReplace,
      });
      return;
    }

    next();
  });
}
